import { apiCall } from "../../services/api-service";

/**
 * Fetch active employees list for From/To user dropdowns
 */
export const getHandoverUsersApi = async () => {
  return await apiCall("get", "get_employee", null, {});
};

/**
 * Fetch tickets available for handover based on from_user_id and filters
 * @param {Object} params { from_user_id, check_assigned_to, check_reporter, check_created_by, status, search, limit, skip }
 */
export const getHandoverTicketsApi = async (params) => {
  const query = new URLSearchParams();
  if (params.from_user_id) query.append("from_user_id", params.from_user_id);
  if (params.check_assigned_to !== undefined) query.append("check_assigned_to", params.check_assigned_to);
  if (params.check_reporter !== undefined) query.append("check_reporter", params.check_reporter);
  if (params.check_created_by !== undefined) query.append("check_created_by", params.check_created_by);
  if (params.search) query.append("search", params.search);
  if (params.limit) query.append("limit", params.limit);
  if (params.skip !== undefined) query.append("skip", params.skip);
  if (params.start_date) query.append("start_date", params.start_date);
  if (params.end_date) query.append("end_date", params.end_date);
  if (params.exp_start_date) query.append("exp_start_date", params.exp_start_date);
  if (params.exp_end_date) query.append("exp_end_date", params.exp_end_date);

  if (params.status && Array.isArray(params.status)) {
    params.status.forEach((st) => query.append("status[]", st));
  } else if (params.status) {
    query.append("status[]", params.status);
  }

  return await apiCall("get", `handover/tickets?${query.toString()}`, null, {});
};

/**
 * Submit ticket handover to target user
 * @param {Object} payload { from_user_id, to_user_id, ticket_ids, check_assigned_to, check_reporter, check_created_by, remarks }
 */
export const submitHandoverApi = async (payload) => {
  return await apiCall("post", "handover/migrate", payload, {});
};

/**
 * Fetch history logs for handovers
 * @param {Object} params { search, limit, skip }
 */
export const getHandoverHistoryApi = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.search) query.append("search", params.search);
  if (params.limit) query.append("limit", params.limit);
  if (params.skip !== undefined) query.append("skip", params.skip);

  return await apiCall("get", `handover/history?${query.toString()}`, null, {});
};

/**
 * Fetch detailed handover history log by history ID
 * @param {number|string} historyId
 * @param {Object} params { status, search, limit, skip }
 */
export const getHandoverHistoryDetailsApi = async (historyId, params = {}) => {
  const query = new URLSearchParams();
  if (params.search) query.append("search", params.search);
  if (params.limit) query.append("limit", params.limit);
  if (params.skip !== undefined) query.append("skip", params.skip);
  if (params.start_date) query.append("start_date", params.start_date);
  if (params.end_date) query.append("end_date", params.end_date);
  if (params.exp_start_date) query.append("exp_start_date", params.exp_start_date);
  if (params.exp_end_date) query.append("exp_end_date", params.exp_end_date);

  if (params.status && Array.isArray(params.status)) {
    params.status.forEach((st) => query.append("status[]", st));
  } else if (params.status) {
    query.append("status[]", params.status);
  }

  return await apiCall("get", `handover/history/${historyId}?${query.toString()}`, null, {});
};
